import { IFileFormData } from "./commonModel";

export interface IOrder {
  id: number,
  orderNo: string,
  customerName: string,
  phoneNumber: string,
  createdOn: string,
  amount: number,
  currency: string,
  note: string,
  isInvoiceSent: boolean,
  invoiceSentOn: string,
  statusId: number,
  statusName: string,
  orderSystemStatusId: number,
  hasNotificationPhoneNumber: boolean,
  hasInvoiceTemplate: boolean,
  notificationPhoneNumber?: string,
  templateName?: string,
  templateLanguage?: string
}

export enum ORDER_SORT {
  ORDER_NO = 'orderNo',
  CUSTOMER_NAME = 'customerName',
  TOTAL = 'amount',
  STATUS = 'statusName',
  NOTE = 'note',
  DATE = 'createdOn',
  INVOICE = 'invoice'
}

//Order system status
export enum ORDER_STATUS {
  Confirmed = 1,
  Cancelled = 2,
  Completed = 3,
}

export interface IOrderSettings {
  waPhoneNumberId?: number;
  invoiceWATemplateId?: number;
  statuses?: IOrderStatus[];
}

export interface IOrderStatus {
    statusId: number;
    name: string;
    englishName: string;
    arabicName: string;
    isSystemStatus: boolean;
    orderStatusTypeId: number;
    isNotify: boolean;
    waTemplateId?: number | null;
    templateName?: string | null;
    orderSystemStatusId?: number;
    isUsed: boolean;
}

export interface IOrderSettingsFormData {
  waPhoneNumberId: number;
  invoiceWATemplateId?: number;
  systemStatuses?: IOrderSystemStatusFormData[];
  customStatuses?: IOrderCustomStatusFormData[];
}

export interface IOrderSystemStatusFormData {
  statusId: number;
  isNotify: boolean;
  waTemplateId?: number | null;
}

export interface IOrderCustomStatusFormData {
    itemId: number;
    statusId: number;
    name?: string;
    englishName: string;
    arabicName: string;
    names?: string;
    isNotify: boolean;
    waTemplateId?: number | null;
    templateName?: string | null;
    isUsed?: boolean
}

export enum ORDER_CUSTOM_STATUS_SORT {
    ID = 'statusId',
    STATUS = 'statusName',
    NOTIFY = 'isNotify',
    TEMPLATE = 'templateName'
}

export interface ISendInvoiceFormData {
    invoiceFile: IFileFormData;
};

export interface ISendInvoiceRequestData {
    orderId: number;
    invoiceFile: IFileFormData;
    recipientNumber: string;
}

export interface IOrderFormData {
  statusId: string,
  note?: string,
}

export interface IOrderDetails {
  id: number,
  orderNo: string,
  statusName: string,
  orderStatusTypeId: number,
  createdOn: string,
  customerName: string,
  itemsList: Array<IItemsList>,
  currency: string,
  amount: number,
  phoneNumber: string,
  statusId: string,
  note?: string,
  isInvoiceSent?: boolean,
  invoiceSentOn?: string,
  isSystemStatus?: boolean,
  isNotify?: boolean,
  waTemplateId?: number,
  merchantInfo: IMerchantInfo,
  templateName?: string,
  templateLanguage?: string,
  orderSystemStatusId:number

}

export interface IItemsList {
  id: number,
  productId: number,
  productName: string,
  quantity: number,
  price: number
}

export interface IMerchantInfo {
  hasNotificationPhoneNumber: boolean,
  notificationPhoneNumber?: string,
  waPhoneNumberId?: number
}

export interface IOrderStatusLookup {
  id: number,
  name: string,
  isSystemStatus: number,
  orderStatusTypeId: number,
  isNotify: boolean,
  waTemplateId?: number,
  orderSystemStatusId?:number,
  templateName?: string,
  templateLanguage?: string
}